import styled from 'styled-components';

const ActionSection = styled.section`
  width: 100%;
  max-width: 540px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Inter UI', sans-serif;
  margin: 32px auto 0px;
`;

export default ActionSection;
